export default (build) =>
  build.mutation({
    query: ({ uid, resources }) => ({
      url: `/superadmin/resources/${uid}`,
      method: "POST",
      body: { resources },
    }),
  });
